module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K21NWXX.a5d64cb7.jpg";